export default __webpack_public_path__ + "static/media/exportorders-white.37405df1.svg";